<!-- 抽屉 -->
<!--
 * @Author: cn1994
 * @Date: 2023-02-28 11:36:56
 * @LastEditors: chenw wchen@lingshi.com
 * @LastEditTime: 2025-03-12 11:16:10
 * @Description: 弹窗组件封装
-->
<template>
    <el-drawer
      ref="customDrawer"
      :class="{ 'ls-custom-double-drawer-component': appendToBody }"
      :title="title"
      :visible.sync="customDrawerShow"
      :size="getWidth"
      :custom-class="customClass"
      :wrapperClosable="false"
      :modal-append-to-body="modalAppendToBody"
      :append-to-body="true"
      :modal="drawerModal"
      :before-close="beforeClose"
      @close="close"
      @open="open"
      v-drawer-close="overlayClose ? close : false"
    >
      <template slot="title">
        <div class="flex-1">
          <slot name="title">{{ title }}</slot>
          <el-tooltip v-if="tooltipShow" placement="bottom-start">
            <span slot="content">
              <div v-html="tooltipContent"></div>
            </span>
            <i class="el-icon-question text-[16px]" style="color: #c8c9cc"></i>
          </el-tooltip>
        </div>
      </template>
      <div class="flex-1 overflow-auto relative">
        <CustomLoading :visible="drawerLoading" />
        <slot name="content">默认内容</slot>
      </div>
      <slot name="footer"></slot>
      <div class="drawer-footer" v-if="hasCancelBtn || hasCancelOk">
        <el-button size="small" @click="cancel" v-if="hasCancelBtn">{{
          cancelText
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="confirmLoading"
          @click="confirm"
          v-click-tracking="confirmTrackData"
          v-if="hasCancelOk"
          >{{ confirmText }}</el-button
        >
      </div>
    </el-drawer>
</template>

<script>
export default {
  props: {
    title: {
      // 标题
      type: String,
      default: "提示",
    },
    //提示内容
    tooltipContent: {
      type: String,
      default: " ",
    },
    //是否展示提示
    tooltipShow: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    hasCancelBtn: {
      //是否显示取消按钮
      type: Boolean,
      default: true,
    },
    hasCancelOk: {
      //是否显示确定按钮
      type: Boolean,
      default: true,
    },
    confirmText: {
      //确定按钮文案
      type: String,
      default: "确定",
    },
    cancelText: {
      //取消按钮文案
      type: String,
      default: "取消",
    },
    overlayClose: {
      //是否点遮罩层关闭
      type: Boolean,
      default: true,
    },
    width: {
      // 宽度
      type: [String, Number],
      default: "465",
    },
    confirmLoading: {
      // 确定按钮loading
      type: [Boolean],
      default: false,
    },
    modalAppendToBody: {
      // 处理多层嵌套样式错乱
      type: [Boolean],
      default: true,
    },
    appendToBody: {
      // 处理多层嵌套样式错乱
      type: [Boolean],
      default: false,
    },
    customClass: {
      // 	Drawer 的自定义类名
      type: [String],
      default: "",
    },
    drawerLoading: {
      // 页面 loadign
      type: [Boolean],
      default: false,
    },
    drawerModal: {
      // 页面 遮罩
      type: [Boolean],
      default: true,
    },
    confirmTrackData: {
      // 确定按钮埋点数据
      type: [Object, String],
      default: () => null,
    },
    beforeClose: {
      // 关闭前回调
      type: [Function],
      default: (done) => {
        done && done()
      },
    }
  },
  data() {
    return {
      customDrawerShow: false,
    };
  },
  computed: {
    getWidth(){
      if (typeof this.width === 'number') {
        return this.width
      }

      if (typeof this.width === 'string' && this.width.includes('%')) {
        return this.width
      } else {
        return Number(this.width)
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVisible) {
        this.customDrawerShow = newVisible;
      },
    },
  },
  methods: {
    confirm(e) {
      this.$emit("confirm");
    },
    cancel(e) {
      this.$emit("cancel");
    },
    close() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
    open() {
      this.$emit("open");
    }
  },
};
</script>

<style lang="less" scoped>
// .ls-custom-drawer-component {
  /deep/ .el-drawer {
    .el-drawer__header {
      padding: 20px;
      height: 60px;

      border-bottom: 1px solid #eeeeee;
      font-size: 16px;
      color: #333333;
      margin-bottom: 0px;
      font-weight: 600;
    }
    .el-drawer__body {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .drawer-footer {
        height: 70px;
        width: 100%;
        border-top: 1px solid #eeeeee;
        background: #ffffff;
        display: flex;
        align-items: center;
        overflow: hidden;
        justify-content: center;
      }
    }
  }

  /deep/.max-h100 {
    max-width: 100vw;
  }
// }
.drawer-footer {
  /deep/ .el-button {
    min-width: 74px;
  }
}
</style>
<style lang="less">
// .ls-custom-double-drawer-component {
  .el-drawer {
    .el-drawer__header {
      padding: 20px;
      height: 60px;

      border-bottom: 1px solid #eeeeee;
      font-size: 16px;
      color: #333333;
      margin-bottom: 0px;
      font-weight: 600;
    }
    .el-drawer__body {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .drawer-footer {
        height: 70px;
        width: 100%;
        border-top: 1px solid #eeeeee;
        background: #ffffff;
        display: flex;
        align-items: center;
        overflow: hidden;
        justify-content: center;
      }
    }
  }
  .drawer-footer {
    .el-button {
      min-width: 74px;
    }
  }
// }
</style>
